"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-secondary-foreground/10 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary-foreground/80 hover:text-ring transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer" className="bg-secondary text-secondary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <img src="https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/Logo.jpg" alt="Logo" className="h-7 w-auto object-contain" />
            <p className="text-secondary-foreground/80 text-sm leading-relaxed font-default pr-4">Twins landscaping Corp is a fully insured and licensed landscaping company proudly serving the Rockland and Orange County areas with comprehensive outdoor design and maintenance solutions. We combine creative design with sustainable practices to create lasting curb appeal.</p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold font-default mb-6 text-secondary-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold font-default mb-6 text-secondary-foreground">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="size-5 text-ring shrink-0 mt-0.5" />
                <Link to="tel:8456596974" className="text-secondary-foreground/80 hover:text-ring transition-colors text-sm font-default">(845)-659-6974</Link>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="size-5 text-ring shrink-0 mt-0.5" />
                <Link to="mailto:Landscapingtwins@gmail.com" className="text-secondary-foreground/80 hover:text-ring transition-colors text-sm font-default break-all">Landscapingtwins@gmail.com</Link>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-ring shrink-0 mt-0.5" />
                <span className="text-secondary-foreground/80 text-sm font-default">
                  Rockland County, NY /<br /> Orange County, NY
                </span>
              </li>
            </ul>
          </div>

          {}
          
        </div>

        {}
        <Separator className="bg-ring/40 mt-16 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <p className="text-secondary-foreground/60 text-sm font-default">
            &copy; {new Date().getFullYear()} Twins Landscaping Corp. All rights reserved.
          </p>
          <p className="text-secondary-foreground/60 text-sm font-default">
            Designed with precision for architectural nature.
          </p>
        </div>
      </div>
    </section>;
}